module.exports = __webpack_public_path__ + "img/p4_bg.b049bdef.jpg";